import * as actionTypes from '../config/actionTypes';
import * as activityFormStates from './components/activityFormStates';

const initialState = {
  loading: false,
  error: null,
  hasError: false,

  activityList: [],
  count: 0,
  next: null,

  activity: null,

  actionLoading: false,
  actionError: null,

  interestForm: activityFormStates.interestForm,
  requestForm: activityFormStates.requestForm,

  shortlisted: false,
  interested: false,
  requested: false,
};


const toggleActivitiesErrorReducer = (state) => {
  return {
    ...state,
    hasError: !state.hasError,
  };
};


const unMountActivitiesReducer = () => {
  return initialState;
};


const showErrorReducer = (state, payload) => {
  return {
    ...state,
    error: payload,
  };
};


const toggleLoadingReducer = (state) => {
  return {
    ...state,
    loading: !state.loading,
  };
};


const showActivityListReducer = (state, payload) => {
  return {
    ...state,
    activityList: [
      ...state.activityList,
      ...payload.results,
    ],
    count: payload.count,
    next: payload.next,
  };
};


const showActivityReducer = (state, payload) => {
  return {
    ...state,
    activity: payload,
  };
};


const toggleActionLoadingReducer = (state) => {
  return {
    ...state,
    actionLoading: !state.actionLoading,
  };
};


const showActionErrorReducer = (state, payload) => {
  return {
    ...state,
    actionError: payload,
  };
};


const updateInputsSerializer = (state, payload) => {
  return {
    ...state,
    [payload.form]: {
      ...state[payload.form],
      ...payload.data,
    },
  };
};


const activitySuccessReducer = (state, payload) => {
  const types = {
    shortlists: 'shortlisted',
    interests: 'interested',
    requests: 'requested',
  };
  return {
    ...state,
    [types[payload]]: true,
  };
};


const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.TOGGLE_ACTIVITIES_ERROR: return toggleActivitiesErrorReducer(state);
    case actionTypes.UNMOUNT_ACTIVITIES: return unMountActivitiesReducer();
    case actionTypes.SHOW_ACTIVITIES_ERROR: return showErrorReducer(state, action.payload);
    case actionTypes.TOGGLE_ACTIVITIES_LOADING: return toggleLoadingReducer(state);
    case actionTypes.SHOW_ACTIVITY_LIST: return showActivityListReducer(state, action.payload);
    case actionTypes.SHOW_ACTIVITY: return showActivityReducer(state, action.payload);
    case actionTypes.TOGGLE_ACTION_LOADING: return toggleActionLoadingReducer(
      state, action.payload,
    );
    case actionTypes.SHOW_ACTION_ERROR: return showActionErrorReducer(state, action.payload);
    case actionTypes.UPDATE_ACTIVITY_INPUTS: return updateInputsSerializer(state, action.payload);
    case actionTypes.ACTIVITY_SUCCESS: return activitySuccessReducer(state, action.payload);
    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/activities/reducers.js